/** Enum used for defining the variant of the loading animation */
export enum LoadingAnimationVariant {
  BLOCK = 'block',
  INLINE = 'inline',
  OVERLAY = 'overlay',
  BUTTON = 'button',
}
